export default __webpack_public_path__ + "static/media/sand3.7e3823cc.png";